'use strict';

angular.module('atex.art').controller('ArtContentDetailsCtrl',
['$scope', '$q', '$rootScope', '$location', '$route', '$timeout', '$routeParams', '$window', '$http', '$injector', 'ArtNotificationService', 'ArtSynchronizationService',
 'ArtContentStore', 'ArtTemplateStore', 'ArtUserDataStore', 'ArtReloadModal', 'ArtConflictModal', 'Application', 'ContentService', 'WorkspaceService', 'PreviewService', 'AuthenticationService',
 'article', 'user', 'ArtLayoutService', 'ArtPrintData', 'CopyfitUtils', 'ArtPreviewService', 'ArtLockingService', 'ClipboardService','CopyfitDialog', '$translate', 'valdr', 'valdrEvents',
 'PageTitle','ArtCommonServices','templates','ArtConfirmModal','ApplicationConfigurationService','UserProfileService', 'UIConfigurationService','SearchService','ArtDeskEmbed',
  function($scope, $q, $rootScope, $location, $route, $timeout, $routeParams, $window, $http, $injector, ArtNotificationService, ArtSynchronizationService,
           ArtContentStore, ArtTemplateStore, ArtUserDataStore, ArtReloadModal, ArtConflictModal, Application, ContentService, WorkspaceService, PreviewService, AuthenticationService,
           article, user, ArtLayoutService, ArtPrintData, CopyfitUtils, ArtPreviewService, ArtLockingService, ClipboardService, CopyfitDialog, $translate, valdrProvider, valdrEvents,
           PageTitle, ArtCommonServices,templates,ArtConfirmModal, ApplicationConfigurationService, UserProfileService,UIConfigurationService,SearchService,ArtDeskEmbed) {

    // "printSyncingCounter" holds a count of operation undergoing on print system (i.e. print lock)
    // in order to disable the save during those operations. See for example "lockAspect" into copyfit-element-channel.js
    var printSyncingCounter = 0;
    var ShapeUtils;
    var ADMUtils;
    var PrintService;

    $scope.$on("atex:incrementPrintSyncingCounter", function () {
      printSyncingCounter++;
      $scope.printSyncing = printSyncingCounter > 0;
    });
    $scope.$on("atex:decrementPrintSyncingCounter", function () {
      printSyncingCounter--;
      $scope.printSyncing = printSyncingCounter > 0;
    });

    $scope.publishEnabled = true;
    $scope.publicationVisible = false;
    $scope.isPublishedToWeb = false;
    $scope.saveAsSilentAfterChange = false;
    $scope.publishButtonBackGroundStyle = "";
    $scope.desk =  {
      showing: false,
      visibleLinkToPage: false,
      visibleSendToQueue: false,
      url: ""
    };

    $timeout(function() {
      if ($routeParams !== undefined && $routeParams.tab !== undefined && $routeParams.force === undefined){
        $("li[x-act-view='" + $routeParams.tab +"'] a").click();
      }
    }, 1000);

    $scope.isPublicationVisible = function() {
      UIConfigurationService.isToolbarVisible("publish-button", $scope.article).then(function (data) {
        $scope.publicationVisible = data;

        if( $scope.publishEnabled && $scope.publicationVisible) {
          getPublicationUrl().then(function(url) {
            $scope.isPublishedToWeb = true;
          }, function (error) {
            if (error && error.data && error.data.statusCode === 50100) {
              $scope.isPublishedToWeb = $scope.hasPublicationLink();
            }
          });
        }
      });
    };
    $scope.forceDefaultSaveButtonToSave = true;
    ApplicationConfigurationService.getConfigurationFor(['forceDefaultSaveButtonToSave'], true).then(function(inbox){
      $scope.forceDefaultSaveButtonToSave = inbox;
      setActiveBackCmd();
    });

    $scope.forceDefaultSaveButtonToSaveAndPublish = false;
    ApplicationConfigurationService.getConfigurationFor(['forceDefaultSaveButtonToSaveAndPublish'], false).then(function(inbox){
      $scope.forceDefaultSaveButtonToSaveAndPublish = inbox;
      setActiveBackCmd();
    });

    $scope.forceUpdatePublicationUrl = true;
    $scope.updateFieldsOnPublication = ['pushNotification'];
    ApplicationConfigurationService.getConfigurationFor(['publish'], {}).then(function(publish){
      $scope.forceUpdatePublicationUrl = (typeof publish.forceUpdatePublicationUrl !== 'undefined') ? publish.forceUpdatePublicationUrl : true;
      $scope.updateFieldsOnPublication = (typeof publish.updateFields !== 'undefined') ? publish.updateFields : ['pushNotification'];
    });

    function parseShortcutKey(shortcuts, name, defaultValue) {
      if (shortcuts) {
        var key = shortcuts[name];
        if (key && key.length === 1 && key.match((/[A-Za-z]/))){
          return key.toUpperCase();
        }
      }
      return defaultValue;
    }

    // By default all shortcuts are disabled.
    // Shortcut keys for commands save, saveAndClose and saveAndPublish should be configured in act-config.json as follows
    // "shortcuts": {
    //       "saveAndClose": "Y",
    //       "save": "M",
    //       "saveAndPublish": "L"
    // }
    $scope.saveShortcutKey = "S";
    // $scope.saveAndCloseShortcutKey = undefined;
    // $scope.saveAndPublishShortcutKey = undefined;
    ApplicationConfigurationService.getConfigurationFor(['shortcuts'], {}).then(function(shortcuts){
      $scope.saveShortcutKey = parseShortcutKey(shortcuts,"save",$scope.saveShortcutKey);
      $scope.saveAndCloseShortcutKey = parseShortcutKey(shortcuts,"saveAndClose",undefined);
      $scope.saveAndPublishShortcutKey = parseShortcutKey(shortcuts,"saveAndPublish",undefined);
    });

    //Method to get the values
    $scope.shortcutKeyResolver = function (type){
      switch (type){
        case "save":
          return $scope.saveShortcutKey;
        case "saveAndClose":
          return $scope.saveAndCloseShortcutKey;
        case "saveAndPublish":
          return $scope.saveAndPublishShortcutKey;
        default:
          return undefined;
      }
    };

    $scope.updatePublishBackgroundButton = function() {
      var colorStyle;
      if ($scope.article && $scope.publishButtonBackStyles) {
        var statusID = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/atex.WebContentStatus/data/status/statusID');
        if (statusID) {
          colorStyle = $scope.publishButtonBackStyles[statusID];
        }
        if (!colorStyle) {
          colorStyle = $scope.publishButtonBackStyles['default'];
        }
      }
      $scope.publishButtonBackGroundStyle = colorStyle || "";
    };

    UIConfigurationService.toolbar("publish-button").then(function (toolbar) {
      if (toolbar && toolbar['background-style']) {
        $scope.publishButtonBackStyles = toolbar['background-style'];
        $scope.publishButtonDefaultBackStyles = toolbar['default'];
        $scope.updatePublishBackgroundButton();
      }
    });

    $scope.isCrossSearchVisible = function() {
      UIConfigurationService.isToolbarVisible("cross-search", $scope.article).then(function (data) {
        $rootScope.$broadcast('atex:cross-search-visible',data);
      });
    };

    $scope.isPublishEnabled = function() {
      return ($scope.publishEnabled && $scope.article.local.existsOnServer && $scope.article.local.valid &&
        $scope.article.local.persisted && !$scope.saving && !disabledFromProfile && !$scope.printSyncing) !== false;
    };

    function saveAndPublish(status) {
      save().then(function () {
        $scope.publishToWeb(status);
      });
    }

    var disabledFromProfile = false;
    $scope.$watch('article.data', function(newValue, oldValue) {
      UserProfileService.disableAction({'action': 'publish', 'application': 'act', 'data': $scope.article.data}).then(function (disable) {
        disabledFromProfile = disable;
      });
    }, true);

    function updateStatusAndWebStatus(serverArticle) {
      function updateLocalAspect(serverArticle, aspectName) {
        var serverAspect = serverArticle.data.aspects[aspectName];
        var localAspect = $scope.article.data.aspects[aspectName];

        if (localAspect && serverAspect) {
          var serverData = serverAspect.data.status || {};
          var localData = localAspect.data.status || {};
          var diff = _.difference(serverData.attributes || [], localData.attributes || []);

          var statusDO = undefined;
          var tmpData = undefined;

          var fetchDO = function() {
            if (statusDO === undefined) {
              statusDO = atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, 'aspects/' + aspectName + '/data');
            }
            return statusDO;
          };

          var fetchData = function() {
            if (tmpData === undefined) {
              tmpData = fetchDO().getData();
            }
            return tmpData;
          };

          if (diff && diff.length > 0) {
            _.each(diff, function(attr, index) {
              fetchData().status.attributes.push(attr);
            });
          }
          if (serverData.statusID !== localData.statusID) {
            fetchData().status.statusID = serverData.statusID;
          }
          if (statusDO && tmpData) {
            console.log('updated aspect', aspectName);
            statusDO.setData(tmpData);
            statusDO.changed();
            return true;
          }
        }
        return false;
      }

      var updated = false;
      updated |= updateLocalAspect(serverArticle, 'atex.WFContentStatus');
      updated |= updateLocalAspect(serverArticle, 'atex.WebContentStatus');

      if (updated) {
        setFresh();
        $scope.saveAsSilentAfterChange = true;
      }

      return $q.when(serverArticle);
    }

    var silent = function () {
      return checkForConflict().then(function(conflict) {
        return ArtCommonServices.storeToServer($scope.article, templates, $rootScope.editChain.get(0)).then(function () {
          setFresh();

          if (typeof $rootScope !== 'undefined') {
            $rootScope.$broadcast('copyfit:printDataRequest', 'saveDataComplete', {});
          }

          $scope.activeBack = $scope.hasChain() ? $scope.goBackCmd : $scope.closeCmd;
          sendEvent($scope.article, "save");
        });
      });
    };

    function getPublicationUrl() {
      var deferred = $q.defer();

      if ($scope.article && $scope.article.meta && $scope.article.meta.id) {
        AuthenticationService.getCurrentUser().then(function (currentUser) {
          sendEvent($scope.article, "get-remote-publication-url");
          var url = "/onecms/dam/content/publicationUrl/contentid/" + $scope.article.meta.id;
          $http({
            method: 'GET',
            url: url,
            headers: {
              'Content-Type': 'text/plain',
              'X-Auth-Token': currentUser.token
            }
          }).then(function (response) {
            deferred.resolve(response.data.url);
          }, function (error) {
            deferred.reject(error);
          });
        });
      } else {
        $timeout(function() {
          deferred.reject("Not Saved");
        });
      }

      return deferred.promise;
    }

    function buildPublicationUrl() {
      return getPublicationUrl().then(function (url) {
        return url;
      }, function (error) {
        if (error && error.data && error.data.statusCode === 50100) {
          return ArtPreviewService.calculatePreviewContext($scope.topDomainObject).then(function (context) {
            return ArtPreviewService.preparePreview('web', $scope.article, {previewContexts: context}, $scope.topDomainObject).then(function (data) {
              return atex.onecms.ObjectUtils.getByPath(data, "data/previewUrl");
            });
          }).then(undefined, function (error) {
            throw error;
          });
        }
      });
    }

    function updatePublicationLink() {
      // with ADM-617 the publicationLink will be calculated directly during the publish process so there is no
      // need to calculate it here, however to make sure this will work even if previous versions of the publishing
      // server code we can force to use the previous flow where we calculate the publishingLink here.
      // By default we will enable the previous flow which can easily be disabled using the act-config.json file.
      var forceUpdate = $scope.forceUpdatePublicationUrl;
      if (!forceUpdate && $scope.hasPublicationLink()) {
        return $q.when(atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, 'aspects/contentData/data/publicationLink'));
      } else {
        return buildPublicationUrl().then(function (url) {
          var context = atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, 'aspects/contentData/data/publicationLink');
          if (context) {
            // if the publicationLink has not been changed there is no need to save.
            if ($scope.article.data.aspects.contentData.data.publicationLink !== url) {
              $scope.article.data.aspects.contentData.data.publicationLink = url;

              context.setData(url);
              context.changed();

              return silent().then(function () {
                return url;
              });
            } else {
              return url;
            }
          } else {
            return url;
          }
        });
      }
    }

    function zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    }

    function updatePublicationDate(serverArticle) {
      $scope.article.data = serverArticle.data;
      serverArticle.meta.id = serverArticle.id;
      serverArticle.meta.revision = serverArticle.revision;
      $scope.article.meta = serverArticle.meta;
      var context = atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, 'aspects/contentData/data/publicationDate');
      if (context && $scope.article.data.aspects.contentData.data.publicationDate === 0) {
        var d = new Date();
        var nUpdatedDate = 0;
        var publEvents =  atex.onecms.ObjectUtils.getByPath(serverArticle, 'data/aspects/atex.dam.standard.Publevents/data/publevents');
        if (publEvents && publEvents.length > 0) {
          var publEvent = publEvents[0];
          if ( publEvent.pubdate && publEvent.pubdate !== "" && publEvent.edition && publEvent.edition !== "" && publEvent.publication && publEvent.publication !== "" && publEvent.page && publEvent.page !== "" ) {
            var queryElemsInfo = {
              core: "onecms",
              fl : "id"
            };
            var qryStr;
            var pubDate = new Date(parseInt(publEvent.pubdate));
            var covdate = pubDate.getFullYear() + "-" + zeroPad(pubDate.getMonth()+1,2) + "-" + zeroPad(pubDate.getDate(),2) ;

            qryStr = '+atex_desk_objectType:("page")+_query_:"{!parent which=\'contentType_atex_desk_s:parentDocument\'}(+edition_atex_desk_ss:(' + publEvent.edition + ')+page_atex_desk_ss:(' + publEvent.page + ')+publication_atex_desk_ss:(' + publEvent.publication + ')+pubdate_atex_desk_ss:(' + covdate + '))"';
            queryElemsInfo['q'] = qryStr;
            return SearchService.search(queryElemsInfo).then(function (result) {
              return result.data.response.docs.map(function (doc) {
                return SearchService.search(queryElemsInfo).then(function (result2) {
                  var queryElemsInfo2 = {
                    core: "onecms",
                    fl : "id"
                  };
                  queryElemsInfo2['q'] = 'logicalPage_atex_desk_sms:"'  + doc.id +'"';
                  return SearchService.search(queryElemsInfo2).then(function (result3) {
                    return result3.data.response.docs.map(function (doc2) {
                      return ContentService.getContent({id: doc2.id}).then(function (serverArticle2) {
                          var publEvents2 =  atex.onecms.ObjectUtils.getByPath(serverArticle2, 'data/aspects/atex.dam.standard.Publevents/data/publevents');
                          if ( publEvents2 && publEvents2.length > 0 ) {
                            var pubDate = new Date(parseInt(publEvents2[0].pubdate));
                            var pubDate2AM = new Date(pubDate.getFullYear(), pubDate.getMonth(), pubDate.getDate(), 2, 0, 0);
                            $scope.article.data.aspects.contentData.data.publicationDate = pubDate2AM.getTime();
                            context.setData(pubDate2AM.getTime());
                            context.changed();

                            return silent().then(function () {
                              return serverArticle;
                            });
                          }
                      });
                    });
                  });
                });
              });
            });
          }
        }

        if (nUpdatedDate === 0) {
          nUpdatedDate = d.getTime();
        }

        $scope.article.data.aspects.contentData.data.publicationDate = nUpdatedDate;

        context.setData(nUpdatedDate);
        context.changed();

        return silent().then(function () {
          return serverArticle;
        });
      }
      return $q.when(serverArticle);
    }

    function updateConfiguredFields(serverArticle) {
      var updateFields = $scope.updateFieldsOnPublication;
      var changed = false;
      var fresh = isFresh();
      for (var idx = 0; idx < updateFields.length; idx++) {
        var name = updateFields[idx];
        var aspectSep = name.indexOf('/');
        var aspectName = 'contentData';
        if (aspectSep > 0) {
          aspectName = name.substring(0, aspectSep) || 'contentData';
          name = name.substring(aspectSep + 1);
        } else if (name.indexOf('.') > 0) {
          aspectName = name;
          name = '';
        }
        var domainObjectPath = (name !== '') ? ('aspects/' + aspectName + '/data/' + name) : ('aspects/' + aspectName);
        var domainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, domainObjectPath);
        if (domainObject) {
          var oldValue = domainObject.getData();
          var newValue = atex.onecms.ObjectUtils.getByPath(serverArticle, 'data/' + domainObjectPath);
          if (typeof oldValue === 'undefined' || oldValue !== newValue) {
            var fieldName = aspectName + (name !== '' ? '.' + name : '');
            console.log('update \'' + fieldName + '\' change from \'' + oldValue + '\' to \'' + newValue + '\'');
            domainObject.setData(newValue);
            domainObject.changed();
            changed = true;
          }
        }
      }
      if (fresh && changed) {
        setFresh();
        $scope.saveAsSilentAfterChange = true;
      }
      return $q.when(serverArticle);
    }

    function getPublicationLink() {
      return getPublicationUrl().then(function(url) {
        return url;
      }, function(error) {
        if (error && error.data && error.data.statusCode === 50100) {
          return atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/contentData/data/publicationLink');
        }
        console.error("Failed to get publication link", error);
        throw error;
      });

    }

    $scope.hasPublicationLink = function() {
      return !!atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/contentData/data/publicationLink');
    };

    $scope.openPublicationLink = function() {
      getPublicationUrl().then(function(url) {
        $window.open(url, '_blank');
      }, function(error) {
        if (error && error.data && error.data.statusCode === 50100) {
          $window.open(atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/contentData/data/publicationLink'), '_blank' );
        }
      });
    };

    $scope.copyPublicationLink = function() {
      getPublicationUrl().then(function(url) {
        textToClipboard(url);
        $scope.clipboardNotificationToast = ArtNotificationService.addNotification(atex.act.Notification({
          type: 'success',
          persistent: false,
          message: $scope.actSuccessMessage
        }), false);
      }, function(error) {
        var message = $scope.actPublicationErrorMessage + " (" + (error.cause || error.statusText) + ")";
        $scope.clipboardNotificationToast = ArtNotificationService.addNotification(atex.act.Notification({
          type: 'error',
          persistent: false,
          message: message
        }), false);
      });
    };

    function textToClipboard (text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }

    $scope.publishToWeb = _.debounce(function() {
      if ($scope.isPublishEnabled()) {
        $scope.publishEnabled = false;
        $scope.publishingError = false;
        $scope.lastPublishingError = "PUBLISH_TO_WEB";

        $scope.showSpinner = true;
        $scope.saving = true;
        $scope.isPublishing = true;

        AuthenticationService.getCurrentUser().then(function (currentUser) {
          sendEvent($scope.article, "publish-to-web");
          var url = "/onecms/dam/content/publish?contentId=" + $scope.article.meta.id;
          $http({
            method: 'POST',
            url: url,
            headers: {
              'Content-Type': 'text/plain',
              'X-Auth-Token': currentUser.token
            },
            timeout: 600000
          }).then(function (response) {
            $rootScope.$broadcast("onecms:content-published", response.data);
            return ContentService.getContent({id: $scope.article.meta.id});
          }).then(function (serverArticle) {
            return updateStatusAndWebStatus(serverArticle);
          }).then(function (serverArticle) {
            return updatePublicationDate(serverArticle);
          }).then(function (serverArticle) {
            return updateConfiguredFields(serverArticle);
          }).then(function (serverArticle) {
            return updatePublicationLink();
          }).then(function () {
            $scope.isPublishedToWeb = true;
            $scope.saving = false;
            $scope.showSpinner = false;
            $scope.isPublishing = false;
            $scope.updatePublishBackgroundButton();
            $scope.clipboardNotificationToast = ArtNotificationService.addNotification(atex.act.Notification({
              type: 'success',
              persistent: false,
              message: $scope.actSuccessMessage
            }), false);
            $scope.publishEnabled = true;
          }).then(null, function (error) {
            $scope.showSpinner = false;
            $scope.saving = false;
            $scope.isPublishing = false;
            $scope.publishingError = true;
            var message = $scope.actPublicationErrorMessage + " (" + ((error.data && error.data.message) || error.cause || error.statusText || error) + ")";
            if (error && error.data && error.data.statusCode === 50023) {
              message = $scope.actPublicationErrorContentLockedMessage;
            }
            $scope.lastPublishingError = message;

            $scope.clipboardNotificationToast = ArtNotificationService.addNotification(atex.act.Notification({
              type: 'error',
              persistent: false,
              message: message
            }), false);
            $scope.publishEnabled = true;
          });
        });
      }
    }, 800, true);

    function sendEvent(content, event) {
      var id = atex.onecms.ObjectUtils.getByPath(article, "meta/id");
      var saved = atex.onecms.ObjectUtils.getByPath(article, "local/existsOnServer") || false;

      if (saved) {
        $window.atex.analytics('event', {e: event, d1: id});
      }
    }

    var oldCopy, newArticle = false, hasPerformedInitialVersionCheck = false;

    sendEvent(article, "edit-content");

    if(typeof article.local.state !== "undefined") {
      $scope.activeView = article.local.state.activeView;
      delete article.local.state;
      ArtContentStore.put(article);
    }

    $scope.initialIntent = $route.current.params.intent || "";

    oldCopy = atex.Content(angular.copy(article.data), angular.copy(article.meta), angular.copy(article.local));
    newArticle = !_.isUndefined($routeParams.type);

    var copyfitUtils = CopyfitUtils();

    $scope.viewsStateArray = [];
    $scope.locale = $translate.use();
    $scope.fresh = true;

    $scope.useActInbox = true;
    $scope.detectChanges = true;

    article.hasErrors = function (view) {
        if ($scope.viewsStateArray.length === 0) {
            //initialize view state array
            for (var layoutView in $scope.article.template.layout.views) {
                var data = [
                    {
                        "label": $scope.article.template.layout.views[layoutView].label,
                        "bool": false
                    }
                ];

                $scope.viewsStateArray.push(data);

            }
        }

        for (var state in $scope.viewsStateArray) {

            if (view.label === $scope.viewsStateArray[state][0].label) {
                //return the state for the current view
                return $scope.viewsStateArray[state][0].bool;
            }
        }
    };

    var isMac = function() {
      return navigator.platform.match('Mac') ? true : false;
    };

    ApplicationConfigurationService.getConfigurationFor(['enbaleShortcutKeys'], true).then(function(enbaleShortcutKeys) {
      if(enbaleShortcutKeys) {

        if(typeof $rootScope.shortcutKeys !== 'object' || typeof $rootScope.shortcutKeys.handler !== 'function') {
          $rootScope.shortcutKeys = {
            handler: function handleShortcutKeys(event) {
              var ctrlKey = isMac() ? event.metaKey : event.ctrlKey;
              var metaKey = isMac() ? event.ctrlKey : event.metaKey;
              var checkEvent = function(shortcutKey, event) {
                return typeof shortcutKey !== 'undefined' && event.which === shortcutKey.charCodeAt(0);
              };
              var processEvent = function(event, broadcastName) {
                if (!$rootScope.shortcutKeys.savePending) {
                  $rootScope.$broadcast(broadcastName);
                  event.preventDefault();
                  return true;
                }
                return false;
              };
              if (!event.shiftKey && !event.altKey && ctrlKey && !metaKey) {
                if (checkEvent($scope.saveShortcutKey, event)) {
                  processEvent(event, 'atex:doSave');
                } else if (checkEvent($scope.saveAndCloseShortcutKey, event)) {
                  processEvent(event, 'atex:doSaveAndClose');
                } else if (checkEvent($scope.saveAndPublishShortcutKey, event)) {
                  processEvent(event, 'atex:doSaveAndPublish');
                }
              }
            },
            savePending: false
          };
        }

        $scope.$on('atex:doSave', function() {
          if($scope.saveCmd.isEnabled() && $scope.article.local.valid) {
            $scope.saveCmd.doCmd();
          }
          $rootScope.shortcutKeys.savePending = false;
        });

        $scope.$on('atex:doSaveAndClose', function() {
          if($scope.saveCmd.isEnabled() && $scope.article.local.valid) {
            $scope.saveAndCloseCmd.doCmd();
          }
          $rootScope.shortcutKeys.savePending = false;
        });

        $scope.$on('atex:doSaveAndPublish', function() {
          if($scope.saveCmd.isEnabled() && $scope.article.local.valid) {
            $scope.saveAndPublishCmd.doCmd();
          }
          $rootScope.shortcutKeys.savePending = false;
        });

        $window.addEventListener("keydown", $rootScope.shortcutKeys.handler, true );
      }
    });


    $scope.osCtrlSymbol = isMac() ? "⌘" : "Ctrl+";

    function getTabsPosition() {
      if(!$rootScope.tabsPosition) {
        $rootScope.tabsPosition = {};
      }

      return $rootScope.tabsPosition;
    }

    angular.element($window).bind("scroll", function() {
      var tabs = angular.element(document).find('.tab-pill.active');
      if (tabs && tabs.length > 0) {
        var index = tabs[0].getAttribute('x-act-view');
        if (!$scope.hasPrevious()) {
          getTabsPosition()['tab-' + index] = {'x-offset': $window.pageXOffset, 'y-offset': $window.pageYOffset};
        }
      }
    });

    $scope.updateActiveView = function(index) {
      $scope.activeView = index;
      if (typeof $rootScope !== 'undefined') {
        $rootScope.$broadcast('adm:viewControl', 'updatActiveView', {index: index});
      }

      var position = getTabsPosition()['tab-' + index] || {'x-offset': 0, 'y-offset': 0};
      $timeout(function() {
        $window.scrollTo({
          top: position['y-offset'],
          left: position['x-offset'],
          behavior: 'auto'
        });
      });
    };

    $scope.isActiveView = function(index) {
      return !$scope.activeView ? index === 0 : index === $scope.activeView;
    };

    $scope.setUseInbox = function() {
      return $q(function(resolve) {
        ApplicationConfigurationService.getConfigurationFor(['useACTInbox'], true).then(function(inbox){
          resolve(inbox);
        });
      });
    };

    $scope.setDetectChanges = function() {
      return ApplicationConfigurationService.getConfigurationFor(['serverDataSynchronization', 'detectChanges'], true).then(function(detectChanges){
          return detectChanges;
      });
    };

    $scope.keepLocalVersion = function(conflictModal) {
      article.meta.revision = $scope.article.local.conflict.revision;
      article.local.conflict = undefined;
      article.local.syncFailed = undefined;

      return ArtContentStore.put($scope.article).then(function() {
        ArtContentStore.removeFromSyncSkipList($scope.article.meta.id);

        if ($scope.saving) {
          return doSave(false);
        }
        if (conflictModal) {
          return conflictModal.destroy();
        }
      });
    };

    $scope.requestConflictResolution = function(conflictList) {
      var conflictModal = ArtConflictModal.create({
        conflictObject: $scope.article.local.conflict,
        conflictList: conflictList,
        suppressCompare: true
      });

      ArtContentStore.addToSyncSkipList($scope.article.meta.id);

      conflictModal.whenResolved().then(function(result) {

        if ( !$scope.detectChanges && result.resolution === 'ignored'){
          article.local.conflict = undefined;
          article.local.syncFailed = undefined;
          $scope.saving = false;

          return ArtContentStore.put(article).then(function() {
            return conflictModal.destroy();
          });
        } else if (result.resolution === 'server') {
          return ArtContentStore.getById($scope.article.meta.id, true, true).then(function() {
            ArtContentStore.removeFromSyncSkipList($scope.article.meta.id);
            if ($scope.closing) {
              close();
            } else {
              $route.reload();
            }
            return conflictModal.destroy();
          });
        } else if (result.resolution === 'local') {
          $scope.keepLocalVersion(conflictModal);
        } else if (result.resolution === 'cancel') {
          $scope.saving = false;
          article.local.syncFailed = undefined;

          return conflictModal.destroy();
        }
      });
    };

    var useInbox = function() {
      return ( $scope.useActInbox || (!ArtCommonServices.shouldClose()) );
    };

    var setFresh = function () {
      $scope.fresh = true;
      setActiveBackCmd();
    };

    var clearFresh = function () {
      $scope.fresh = false;
      setActiveBackCmd();
    };

    var isSaved = function () {
      return article.local.existsOnServer && article.local.persisted;
    };

    var isFresh = function () {
      return $scope.fresh;
    };

    var isNew = function () {
      return (/\/new\//).test($location.path());
    };

    var unlockArticle = function () {
      if (article.local.existsOnServer && article.local.persisted) {
        return ArtLockingService.unlock([article.meta.id]);
      }
    };

    var unlockOnDiscard = function () {
      if (article.local.existsOnServer && oldCopy.local.persisted) {
        return ArtLockingService.unlock([$scope.article.meta.id]);
      }
    };

    $scope.getDisplayTitle = function (content) {
      if (typeof content.template === 'undefined' || typeof content.template.namePath === 'undefined') {
        return '[' + content.meta.id + ']';
      }

      var path = JSON.parse(JSON.stringify(content.template.namePath || ["name"]));
      var pathArray = atex.onecms.ObjectUtils.expandShortPath(path);
      var name = atex.onecms.ObjectUtils.getByPath(content.data.aspects, pathArray);

      var displayTitle = name.trim();

      if (typeof displayTitle === 'undefined' || displayTitle.length === 0) {
        return (typeof content.template.label !== 'undefined') ? content.template.label + ' [' + content.meta.id + ']' : '[' + content.meta.id + ']';
      }

      return "'" + displayTitle + "'";
    };

    $scope.stripHTML = function (html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    };

    $scope.getWindowTitle = function (content) {
      if (typeof content.template === 'undefined' || typeof content.template.namePath === 'undefined') {
        return '?';
      }

      var path = JSON.parse(JSON.stringify(content.template.namePath || ["name"]));
      var pathArray = atex.onecms.ObjectUtils.expandShortPath(path);
      var name = atex.onecms.ObjectUtils.getByPath(content.data.aspects, pathArray);

      if (name === undefined || name === "") {
        return 'new';
      }

      //<p>Article Title</p>; Title is surrounded with html tags so remove it to display at the header.
      name = $scope.stripHTML(name);
      $rootScope.$broadcast('headerTitle', name.trim());

      return name.trim();
    };

    $scope.isNamePresent = function (content) {
      if (typeof content.template === 'undefined' || typeof content.template.namePath === 'undefined') {
        return false;
      }
      var path = JSON.parse(JSON.stringify(content.template.namePath || ["name"]));
      var pathArray = atex.onecms.ObjectUtils.expandShortPath(path);
      var name = atex.onecms.ObjectUtils.getByPath(content.data.aspects, pathArray);

      if (name !== undefined && name !== "") {
        return true;
      }
      return false;
    };

    $scope.getPreviousTooltip = function () {
      if ($rootScope.editChain.hasPrevious()) {
        return "Go back to " + $scope.getDisplayTitle($rootScope.editChain.getPrevious());
      }

      return "Go back to previous content";
    };

    $scope.getNextTooltip = function () {
      if ($rootScope.editChain.hasNext()) {
        return "Go forward to " + $scope.getDisplayTitle($rootScope.editChain.getNext());
      }

      return "Go forward to next content";
    };

    var createEditChain = function () {
      var editChain = [];
      var index = -1;
      var processRemoved = undefined;

      var goTo = function (index) {
        if (index < 0) {
          index = 0;
        }

        $location.path("/edit/" + editChain[index].meta.id);
      };

      return {
        setProcessRemoved: function (processRemovedFn) {
          processRemoved = processRemovedFn;
        },
        add: function (resource) {
          if (index < 0) {
            editChain.push(resource);
            index++;
          } else if (index >= 0 && editChain[index].meta.id === resource.meta.id) {
            editChain[index] = resource;
          } else if (index >= 0 && editChain[index].meta.id !== resource.meta.id) {


            if (typeof processRemoved !== 'undefined') {
              processRemoved(editChain.splice(index + 1));
            } else {
              editChain.splice(index + 1);
            }

            editChain.push(resource);
            index++;
          }
        },

        replace: function (resource, position) {
          editChain[position] = resource;
        },

        get: function (position) {
          return editChain[position];
        },

        hasPrevious: function () {
          return index > 0;
        },

        hasNext: function () {
          return index < editChain.length - 1;
        },

        getPrevious: function () {
          return editChain[index - 1];
        },

        getNext: function () {
          return editChain[index + 1];
        },

        goToPrevious: function () {
          goTo(--index);
        },

        goToNext: function () {
          goTo(++index);
        },

        size: function () {
          return editChain.length;
        },

        clear: function () {
          editChain = [];
          index = -1;
        },

        sliceFrom: function (id) {
          var chainObject = _.find(editChain, function (entry) {
            return entry.meta.id === id;
          });

          if (typeof chainObject !== 'undefined') {
            if (typeof processRemoved !== 'undefined') {
              processRemoved(editChain.splice(editChain.indexOf(chainObject)));
            } else {
              editChain.splice(editChain.indexOf(chainObject));
            }
          }
        },

        forEach: function (callbackFn) {
          editChain.forEach(function (resource) {
            callbackFn(resource);
          });
        }
      };
    };

    $scope.hasPrevious = function () {
      return $rootScope.editChain.hasPrevious();
    };

    $scope.hasNext = function () {
      return $rootScope.editChain.hasNext();
    };

    $scope.goToPrevious = function () {
      if ( $rootScope.editChain.hasPrevious() ) {
        $rootScope.editChain.goToPrevious();
      }
    };

    $scope.goToNext = function () {
      if ( $rootScope.editChain.hasNext() ) {
        $rootScope.editChain.goToNext();
      }
    };

    $scope.hasChain = function () {
      return $rootScope.editChain && $rootScope.editChain.size() > 1;
    };

    var editChainSendPrintData = function (resources, sendOptions) {
      var additionalPromises = [];

      resources.forEach(function (resource) {
        if (ArtPrintData.hasLockedElements(resource)) {
          sendOptions.article = resource;
          var promise = ArtPrintData.sendPrintData(sendOptions).then(function (article) {
            return $q.when();
          }, function (response) {
            console.log("editChainSendPrintData response = ", response);
          });

          additionalPromises.push(promise);
        }
      });

      return $q.all(additionalPromises);
    };

    var editChainHasLockedElements = function (resources) {
      var hasLockedElements = false;
      resources.forEach(function (resource) {
        if (ArtPrintData.hasLockedElements(resource)) {
          hasLockedElements = true;
        }
      });
      return hasLockedElements;
    };

    var commitPrintChanges = function (resources, onComplete) {
      if (editChainHasLockedElements(resources)) {
        var modalOptions = {
          confirmHeader: "Print Changes",
          confirmBody: "Commit changes and unlock",
          buttons: [
            {
              label: "OK",
              click: function () {
                editChainSendPrintData(resources, {
                  save: true,
                  unlock: true,
                  rootScope: $rootScope,
                  topDomainObject: $scope.topDomainObject
                }).then(function () {
                  if (typeof onComplete === 'function') {
                    onComplete();
                  }
                });
              },
              dismiss: true
            },
            {
              label: "Cancel", default: true, dismiss: true
            }
          ]
        };

        CopyfitDialog.showModal(modalOptions);

      } else {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      }
    };

    var saveViewState = function(save) {
      if(save && typeof $scope.activeView !== "undefined" && $scope.activeView > 0) {
        if(typeof article.local.state === "undefined") {
          $scope.article.local.state = {};
        }
        $scope.article.local.state.activeView = $scope.activeView;

        return ArtContentStore.put($scope.article);
      }
      return $q.when();
    };


    if (typeof $rootScope.editChain === 'undefined') {
      $rootScope.editChain = createEditChain();
    }

    // Whenever a new content is created, we clear the edit chain...
    if (newArticle === true && typeof $rootScope.editChain !== 'undefined') {
      $rootScope.editChain.clear();
    }

    $rootScope.editChain.add(article);
    $rootScope.editChain.setProcessRemoved(commitPrintChanges);
    if (typeof $rootScope.printOffline === 'undefined') {
      $rootScope.printOffline = false;
    }
    if (typeof $rootScope.printOfflineAcknowledged === 'undefined') {
      $rootScope.printOfflineAcknowledged = false;
    }

    var getPreviousContent = function(content) {
      var previousContent = atex.Content(angular.copy(content.data), angular.copy(content.meta), angular.copy(content.local));
      previousContent.local.existsOnServer = true;
      previousContent.local.persisted = true;
      previousContent.local.valid = true;
      previousContent.local.conflict = false;
      previousContent.meta = {
        id: content.id,
        creationDate: new Date(Number(content.meta.originalCreationTime)),
        modificationDate: new Date(Number(content.meta.modificationTime)),
        revision: content.revision
      };
      previousContent.isBeingSent = true;
      previousContent.template = ArtCommonServices.getTemplateFor(article, templates);
      return previousContent;
    };

    var getFilterAspects = function() {
      return ApplicationConfigurationService.getConfigurationFor(['filterAspects'],
          ["atex.ChannelContentData", "engagementAspect"]);
    };

    function checkAndMergeContent(serverArticle) {
      function tryMergeArray(key, localData, srcData, serverData) {
        if (_.isEqual(localData[key], serverData[key])) {
          return false;
        }
        // Here at least one of the two array must contain a value, so let's check the nature of the array
        var isString;
        var localValue = localData[key].length > 0 ? localData[key][0] : undefined;
        var localType = localData[key + '_element_types'].length > 0 ? localData[key + '_element_types'][0] : undefined;
        if (localValue) {
          isString = typeof localValue === 'string';
        } else {
          var serverValue = serverData[key].length > 0 ? serverData[key][0] : undefined;
          localType = serverData[key + '_element_types'].length > 0 ? serverData[key + '_element_types'][0] : undefined;
          isString = typeof serverValue === 'string';
        }
        if (!isString) {
          // in case of complex Array, let's always keep the server version
          localData[key] = serverData[key];
          localData[key + '_element_types'] = serverData[key + '_element_types'];
          return true;
        }
        // Try to merge strings array in an easy way: let's check if items have only been added
        // from server without rearranging (i.e. LayServer adding images)
        if (srcData[key] && serverData[key] && serverData[key].length > srcData[key].length) {
          var serverSize = serverData[key].length;
          var srcSize = srcData[key].length;
          var newItems = [];
          for (var i = 0; i< serverSize; i++) {
            if (i < srcSize) {
              if (srcData[key][i] !== serverData[key][i]) {
                // The order is not the same or items have been removed serverside
                break;
              }
            } else {
              // collect added entries
              newItems.push(serverData[key][i]);
            }
          }
          var addedSize = newItems.length;
          if (addedSize > 0) {
            for (var j = 0; j< addedSize; j++) {
              if (localData[key].indexOf(newItems[j]) < 0) {
                localData[key].push(newItems[j]);
              }
            }
            var localSize = localData[key].length;
            localData[key + '_element_types'] = [];
            while (localSize--) {
              localData[key + '_element_types'].push(localType);
            }
            return true;
          }
        }
        // In all other cases keep the server version
        localData[key] = serverData[key];
        localData[key + '_element_types'] = serverData[key + '_element_types'];
        return true;
      }

      function checkAspectData(local, src, server) {
        var keys = _.keys(server), key;
        var size = keys.length;
        var changed = false;
        while (size--) {
          key = keys[size];
          if (key.endsWith('_element_types')) {
            continue;
          }
          if (!_.has(local, key) && !_.has(src, key)) {
            // If field has been added on server, let's add to our local data
            local[key] = server[key];
            changed = true;
            continue;
          }
          if (_.has(local, key) && !_.has(src, key)) {
            // If we have local[key] but no src[key] we mark as changed if
            // there is a server[key] and it's not equal to local[key]
            if (_.has(server, key) && !_.isEqual(local[key], server[key])) {
              local[key] = server[key];
              changed = true;
            }
            continue;
          }
          if (_.has(local, key)) {
            if (!_.has(server, key)) {
              // If we are here, we have local[key] and src[key] but NOT server[key]
              // so if has changed we keep it otherwise we remove the local[key]
              if (_.isEqual(local[key], src[key])) {
                delete local[key];
                changed = true;
              }
              continue;
            }
            // If field is still in local data, check what should we do
            var localChanged = !_.isEqual(src[key], local[key]);
            var serverChanged = !_.isEqual(src[key], server[key]);
            if (localChanged && serverChanged) {
              // if both changed, let's only try to merge simple 'string' array
              if (Array.isArray(server[key])) {
                if (tryMergeArray(key, local, src, server)) {
                  changed = true;
                }
              } else if (server[key] instanceof Object) {
                if (checkAspectData(local[key], src[key], server[key])) {
                  changed = true;
                }
              } else {
                // in case both changes, let's keep the server version
                local[key] = server[key];
                changed = true;
              }
            } else if (serverChanged) {
              // If changed only on server side, let's bring it
              local[key] = server[key];
              changed = true;
            }
          }
        }
        return changed;
      }

      function checkAspects(local, src, server) {
        var keys = _.keys(server), key;
        var size = keys.length;
        // Check for filter aspect (keep always the server version)
        return getFilterAspects().then(function(filterAspects) {
          while (size--) {
            key = keys[size];
            if (_.has(local, key) && _.has(src, key)) {
              if (filterAspects && filterAspects.length > 0 && filterAspects.indexOf(key) >= 0) {
                local[key] = server[key];
              } else {
                if (checkAspectData(local[key].data, src[key].data, server[key].data)) {
                  console.log('ASPECT changed into checkAndMergeContent: ', key);
                }
              }
            } else if (!_.has(local, key) && !_.has(src, key)) {
              // The aspect has been added on server
              local[key] = server[key];
            }
          }
        });
      }

      var transferInfo = {id: $scope.article.meta.revision.replace(/["]+/g, '')};
      return ContentService.getContent(transferInfo).then(function (origArticle) {
        return checkAspects($scope.article.data.aspects, origArticle.data.aspects, serverArticle.data.aspects);
      });
    }

    $scope.setArticle = function () {


      return $q(function (resolve, reject) {

        $scope.setUseInbox().then(function(inbox){
          $scope.useActInbox = inbox;
        });

        $scope.setDetectChanges().then(function(detectChanges) {
          $scope.detectChanges = detectChanges;
        });

        var useModifiedArticle = function() {
          article.local.valid = true;
          $scope.fresh = false;
          $scope.article = article;
          ArtLockingService.lock([$scope.article.meta.id]);
        };

        if(!article.local.existsOnServer) {
          $scope.article = article;
          return resolve($scope.article);
        }

        if (!article.local.persisted) {
          $scope.article = article;
          // First load DB content
          ContentService.getContent({id: article.meta.id}).then(function (serverArticle) {
            oldCopy = getPreviousContent(serverArticle);
            // Check if revision has changed
            if (article.meta.revision === serverArticle.revision) {
              // If the revision is the same, use local not persisted content
              var notification = atex.act.Notification({
                type: 'warning',
                persistent: false,
                message: 'Loaded modified article'
              });
              $scope.loadedModifiedArticleToast = ArtNotificationService.addNotification(notification, false, function(){});
              useModifiedArticle();
              return resolve($scope.article);
            } else {
              return checkAndMergeContent(serverArticle).then(function() {
                var notification = atex.act.Notification({
                  type: 'warning',
                  persistent: false,
                  message: 'Loaded merged article'
                });
                $scope.loadedModifiedArticleToast = ArtNotificationService.addNotification(notification, false, function(){});
                useModifiedArticle();
                ArtContentStore.put($scope.article).then(function () {
                  $q.when(ArtLockingService.lock([$scope.article.meta.id])).then(function(){
                    return resolve($scope.article);
                  });
                });
              });
            }
          });
        } else if ( ((!article.local.existsOnServer) || (!article.local.persisted)) && (!article.data.contentUpdated) ) {
          var confirmModal = ArtConfirmModal.create({
            'confirmHeader': 'Are you sure?',
            'confirmBody': '<strong>WARNING:</strong> The article contains local changes NOT synchronized with the saved version. Are you sure you want to continue to edit it?',
            'cancel': 'No, restore saved version',
            'ok': 'Ok, I want edit this version',
            'mode': 'danger'
          });

          confirmModal.then(function (confirmed) {
            if (confirmed) {
              useModifiedArticle();
              return resolve($scope.article);
            } else {
              ContentService.getContent({id: article.meta.id}).then(function (result) {
                oldCopy = getPreviousContent(result);

                article = oldCopy;
                $scope.article = article;

                ArtContentStore.put(oldCopy).then(function () {
                  setFresh();
                  $q.when(ArtLockingService.lock([$scope.article.meta.id])).then(function(){
                    return resolve($scope.article);
                  });
                });
              });
            }
          });
        } else {
          $scope.article = article;
          $q.when(ArtLockingService.lock([$scope.article.meta.id])).then(
            function(){
              return resolve($scope.article);
            }
          );
        }
      });
    };

    $scope.articleLoaded = false;
    $scope.setArticle().then(function () {
      if (article.data.contentUpdated) {
        $scope.fresh = false;
        delete article.data.contentUpdated;
      }

      if(!$scope.article.data.aspects['atex.Metadata']) {
        $scope.article.data.aspects['atex.Metadata'] = {
          data: {
            _type: 'atex.Metadata',
            taxonomyIds: ['p.StandardCategorization'],
            metadata: {
              _type: "com.polopoly.metadata.Metadata",
              dimensions: []
            }
          }
        };
      }

      $scope.articleLoaded = true;

      $scope.isPublicationVisible();
      $scope.isCrossSearchVisible();

      ArtDeskEmbed.initSaveAndSend($scope);

      $scope.user = user;
      $scope.alive = true;
      $scope.isContentEditorLoading = false;
      $scope.versionCheckToast = undefined;
      $scope.versionCheckPromise = undefined;
      $scope.copyfit = undefined;
      $scope.copyfitActive = false;

      // Copy is enabled as long as this is a content present on the server and (to be safe) NOT a draft
      $scope.copyEnabled = atex.onecms.OneCMSUtils.isNewContentId(article.meta.id) && article.meta.id.indexOf('draft:') === -1;

      $scope.webPreviewInProgress = false;
      $scope.webPreviewContexts = undefined;
      $scope.webPreviewErrorMessage = undefined;
      $scope.webPreviewPossibleContexts = [];

      $scope.webPreviewEnabled = (atex.onecms.ObjectUtils.getByPath(article.template, 'webPreviewEnabled') === true);
      $scope.printPreviewDisabled = (atex.onecms.ObjectUtils.getByPath(article.template, 'printPreviewDisabled') === true);


      $rootScope.PageTitle = PageTitle;
      PageTitle.setTitle($scope.getWindowTitle(article));

      _.extend($scope, atex.act.ViewUtils);

      ArtSynchronizationService.enableAutoSync([$scope.article.meta.id]);
      ArtContentStore.addToSyncSkipList($scope.article.meta.id);

      if ($scope.detectChanges && $scope.article.local.existsOnServer && !newArticle && (!$scope.article.local.conflict || !hasPerformedInitialVersionCheck)) {
        var versionCheck = function () {
          var transferInfo = {id: $scope.article.meta.id};
          hasPerformedInitialVersionCheck = true;
          ContentService.getContent(transferInfo).then(function (serverArticle) {
            if (!$scope.alive) {
              return;
            }

            // If there is no new version on server, just re-schedule another check in the future
            if ($scope.article.meta.revision === serverArticle.revision) {
              if (ArtSynchronizationService.delay >= 0) {
                $scope.versionCheckPromise = $timeout(versionCheck, ArtSynchronizationService.delay, true);
              }

              return;
            }

            var notification = atex.act.Notification({
              type: 'info',
              persistent: true,
              message: 'There is a newer version available.'
            });

            $scope.versionCheckToast = ArtNotificationService.addNotification(notification, false, function () {
              $scope.$apply(function () {
                var modal = ArtReloadModal.create({
                  localChanges: !$scope.article.local.persisted || $scope.article.dirty
                });

                return modal.whenResolved().then(function (result) {
                  if (result.resolution === 'server') {
                    return ArtContentStore.getById($scope.article.meta.id, true).then(function () {
                      $route.reload();
                      return modal.destroy();
                    });
                  } else if (result.resolution === 'local') {
                    return ArtContentStore.setConflictState($scope.article, serverArticle).then(function () {
                      return ArtContentStore.setConflictState(oldCopy, serverArticle);
                    }).then(function () {
                      return ArtContentStore.put($scope.article);
                    }).then(function () {
                      return modal.destroy();
                    });
                  }
                }, function (error) {
                  if (ArtSynchronizationService.delay >= 0) {
                    $scope.versionCheckPromise = $timeout(versionCheck, ArtSynchronizationService.delay, true);
                  }

                  console.log('WARNING: Failed to perform version resolution process!', error);
                });
              });
            });
          }, function (error) {
            if (ArtSynchronizationService.delay >= 0) {
              $scope.versionCheckPromise = $timeout(versionCheck, ArtSynchronizationService.delay, true);
            }

            console.log('WARNING: Failed to perform server version verification process!', error);
          });
        };

        $scope.versionCheckPromise = $timeout(versionCheck, 0, true);
      }

      valdrProvider.setValidation($scope.article.template);
    });

    var shouldSavePrintData = function() {
      if ( $scope.printPreviewDisabled ) {
        return false;
      }

      return $scope.copyfitActive && ArtPrintData.shouldSendPrintData( $scope.article );
    };

    var shouldUnlockPrintElements = function() {
       return ArtPrintData.hasLockedElements( $scope.article );
    };

    $scope.doWebPreview = function(specificContext) {
      if ($scope.webPreviewEnabled === false) {
        console.warn('Web preview called for a type without support, ignoring request...');
        return;
      }

      delete $scope.webPreviewErrorMessage;

      var contextCalculationPromise = (typeof $scope.webPreviewContexts === 'undefined')
        ? ArtPreviewService.calculatePreviewContext($scope.topDomainObject)
        : $q.when($scope.webPreviewContexts);

      $scope.webPreviewInProgress = true;

      contextCalculationPromise.then(function(context) {
        $scope.webPreviewContexts = context;

        var data = {
          previewContexts: (typeof specificContext !== 'undefined') ? [specificContext] : $scope.webPreviewContexts
        };

        return ArtPreviewService.preparePreview('web', $scope.article, data, $scope.topDomainObject);
      }).then(function(previewResult) {
        ArtPreviewService.openPreview(previewResult, $scope.article.meta.id);
      }).then(undefined, function(error) {
        console.log('Error while generating web preview!', error);

        var errorMessage;

        if (typeof error.rootCause !== 'undefined' && typeof error.rootCause.response !== 'undefined' && typeof error.rootCause.response.message !== 'undefined') {
          errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined')
            ? 'Error while generating web preview. ' + error.cause + ': ' + error.rootCause.response.message
            : 'Error while generating web preview: ' + error.rootCause.response.message;
        } else {
          errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined')
            ? 'Error while generating web preview: ' + error.cause
            : 'Error while generating web preview.';
        }

        $scope.webPreviewErrorMessage = errorMessage;
      }).then(function() {
        $scope.webPreviewInProgress = false;
      });
    };

    $scope.doCopyToClipboard = _.debounce( function() {

      var clipboardInfo = {
        data: [
          {
            id: 'contentid/' + $scope.article.meta.id,
            type: $scope.article.template.type
          }
        ]
      };

      ClipboardService.putInClipboard(clipboardInfo).then(function() {

        var notification = atex.act.Notification({
          type: 'success',
          persistent: false,
          message: 'The item has been copied to the clipboard.'
        });
        $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function(){});

      }, function(error) {

        var notification = atex.act.Notification({
          type: 'error',
          persistent: false,
          message: 'Failed to copy the item to the clipboard.'
        });
        $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function(){});
      });
    }, 500, true);

    delete $rootScope.lastCurrent;
    $scope.$on('$locationChangeStart', function(event, next, current) {
      var IsBackToList = function( uri ) {
        var strUri = String( uri );
        var uriIndex = strUri.indexOf('/act/');

        return ( uriIndex > 0 ) ? strUri.substring(uriIndex+5).replace(/\#\//ig, '').length <= 0 : false;
      };

      $rootScope.lastCurrent = current.substring(current.indexOf('/edit/'));

      if($rootScope.editResource) {
        saveViewState(true);
      }
      delete $rootScope.editResource;

      var unlock;
      if($scope.hasChain()) {
        // Clear the editChain, if needed, without waiting for the unlockArticle otherwise we could clear the editChain
        // after the $rootScope.editChain.add(article) call (i.e. going back after an image crop) [max]
        if(!$rootScope.editChain.getPrevious()) {
          $rootScope.editChain.clear();
        }
        unlock = $q.when(unlockArticle());
      } else {
        unlock = $q.when();
      }

      unlock.then(function() {
        if ( inhibitPrintAccess || !IsBackToList(next) ) {
          return;
        }

        delete $rootScope.lastCurrent;
        var commit;
        if ( $scope.hasChain() ) {
          commit = commitPrintChanges($rootScope.editChain).then(function(){

          });
          return;
        }

        if ( !saveDone ) {
          if ( !isFresh() && shouldSavePrintData() ) {
            var answer = confirm("Leaving the page will discard any changes.");
            if (!answer) {
              event.preventDefault();
              return;
            }
          }

          if (shouldSavePrintData()) {
            ArtPrintData.sendPrintData({
              article: $scope.article,
              save: false,
              unlock: true,
              onComplete: discardChanges,
              rootScope: $rootScope,
              topDomainObject: $scope.topDomainObject
            });
          } else if (typeof printData !== 'undefined') {
            ArtPrintData.sendPrintData({
              article: $scope.article,
              save: false,
              unlock: true,
              onComplete: discardChanges,
              rootScope: $rootScope,
              topDomainObject: $scope.topDomainObject
            });
          }
        }
      });

    });

    var saveOnUnload = false;
    var unlockOnUnload = false;
    var actReloaded = false;
    var saveDone = false;
    var inhibitPrintAccess = false;

    var onUnloadFn = function() {

      // send message to server to unlock current article id when window closes
      navigator.sendBeacon('/onecms/dam/content/unlock/' + $scope.article.meta.id + '/' + Application.currentUser.principalId + '/atex.act', '{ "token": "' + Application.currentUser.token + '"}');

      if (unlockOnUnload) {
        ArtPrintData.sendPrintData({
          article: $scope.article,
          save: false,
          unlock: true,
          rootScope: $rootScope,
          topDomainObject: $scope.topDomainObject,
          unload: true
        });
        $rootScope.$digest();
      }
    };

    var onBeforeUnloadFn = function() {
      var prompt = false;
      unlockOnUnload = shouldUnlockPrintElements( $scope.article );

      if ( $scope.copyfitActive && !isFresh() && shouldSavePrintData() ) {
        prompt = true;
        unlockOnUnload = true;

      } else if(!$scope.article.local.persisted && !$scope.article.isBeingSent && !$scope.article.local.conflict) {
        prompt = true;
        unlockOnUnload = true;
      } else if($scope.hasChain()) {
        prompt = true;
      }

      if(prompt) {
        // Cancel the event as stated by the standard.
        event.preventDefault();
        // Chrome requires returnValue to be set.
        event.returnValue = '';
      }
    };

    $window.addEventListener('beforeunload', onBeforeUnloadFn);

    $window.onunload = onUnloadFn;

    $scope.$on('$destroy', function() {
      $scope.alive = false;

      saveOnUnload = false;
      unlockOnUnload = false;

      if (typeof $rootScope.shortcutKeys === 'object' && typeof $rootScope.shortcutKeys.handler === 'function') {
        $window.removeEventListener("keydown", $rootScope.shortcutKeys.handler, true);
        $rootScope.shortcutKeys = undefined;
      }

      $window.removeEventListener('beforeunload', onBeforeUnloadFn);
      $window.onunload = undefined;

      sessionStorage.setItem("act.loaded", "");

      if($scope.versionCheckPromise) {
        $timeout.cancel($scope.versionCheckPromise);
      }

      if (typeof $scope.editChainEventHandler !== 'undefined') {
        $scope.editChainEventHandler();
      }

      ArtSynchronizationService.disableAutoSync();
      ArtContentStore.removeFromSyncSkipList($scope.article.meta.id);

      if (typeof $scope.versionCheckToast !== 'undefined') {
        ArtNotificationService.clearToast($scope.versionCheckToast);
        $scope.versionCheckToast = undefined;
      }

      if (typeof $scope.siteSelectionToast !== 'undefined') {
        ArtNotificationService.clearToast($scope.siteSelectionToast);
        $scope.siteSelectionToast = undefined;
      }

      if (typeof $scope.loadedModifiedArticleToast !== 'undefined') {
        ArtNotificationService.clearToast($scope.loadedModifiedArticleToast);
        $scope.loadedModifiedArticleToast = undefined;
      }
    });

    $scope.$on('atex:contentSynchronized', function(event, updatedId, doRemove) {
      if (updatedId === $scope.article.meta.id) {
        if (newArticle) {
          return;
        }

        var refreshedArticle = undefined;

        ArtContentStore.getById(article.meta.id).then(function(article) {
          refreshedArticle = article;
          return ArtTemplateStore.getTemplateFor(article);
        }).then(function(template) {
          refreshedArticle.template = template;
          $scope.article = refreshedArticle;
        });
      }
    });

    function toggleIntent(template, intent) {
      if ( typeof template.layout === 'undefined' ) {
        // not using views.
        for (var bindingIdx in template.dataBindings) {
          var templateFieldElement = copyfitUtils.findTemplateFieldByFieldIndex( bindingIdx );

          if (typeof templateFieldElement !== 'undefined') {
            var dataBinding = template.dataBindings[bindingIdx];
            var hasIntent = intent;

            if (typeof dataBinding !== 'undefined' && typeof dataBinding.config !== 'undefined') {
               hasIntent = copyfitUtils.getIntent(dataBinding.config.intents, intent);
            }

            copyfitUtils.displayControl(templateFieldElement, hasIntent);
          }
        }
         return;
      }

      var templateViewElements = $('.tab-pane[x-act-view],.tab-pill[x-act-view]');

      /* jshint -W004 */
      for (var viewElIdx = 0; viewElIdx < templateViewElements.length; viewElIdx++ ) {
        var viewElement = templateViewElements[viewElIdx];
        var view = template.layout.views[$(viewElement).attr('x-act-view')];

        copyfitUtils.displayControl(viewElement, copyfitUtils.getIntent(view.intents, intent));

        for (var fieldIndex in view.fields) {

          var dataBinding = _.find(template.dataBindings, function(binding) {
            return view.fields[fieldIndex] === binding.name;
          });

          var hasIntent = intent;

          if (typeof dataBinding === 'undefined') {
            console.warn("No data binding using the name '" + view.fields[fieldIndex] + "' could be found, skipping...");
          }

          if (typeof dataBinding !== 'undefined' && typeof dataBinding.config !== 'undefined') {
            hasIntent = copyfitUtils.getIntent(dataBinding.config.intents, intent);
          }

          var templateFieldElement = copyfitUtils.findTemplateFieldByView(view.name, fieldIndex);

          if (typeof templateFieldElement !== 'undefined') {
            copyfitUtils.displayControl(templateFieldElement, hasIntent);
          }
        }
      }
      /* jshint +W004 */
    }

    $scope.$on(valdrEvents.validated, function(event) {
        if ( $scope.myForm.$valid !== undefined && $scope.article.local.valid !== $scope.myForm.$valid ) {
            saveArticle(false, $scope.article.data);
        } else {
            //reset the state for all views
            for (var viewStateIdx in $scope.viewsStateArray) {
                $scope.viewsStateArray[viewStateIdx][0].bool = false;
            }

            for (var invalidFieldIndex in event.currentScope.myForm.$error.valdr) {
                for (var viewIdx in event.currentScope.article.template.layout.views) {
                    if (event.currentScope.article.template.layout.views[viewIdx].fields.indexOf(event.currentScope.myForm.$error.valdr[invalidFieldIndex].$name) !== -1) {
                        for (var stateIdx in $scope.viewsStateArray) {
                            if ($scope.viewsStateArray[stateIdx][0].label === event.currentScope.article.template.layout.views[viewIdx].label){
                                $scope.viewsStateArray[stateIdx][0].bool = true;
                            }
                        }
                    }
                }
            }
        }
    });

    $scope.$on('copyfit:previewControl', function(event, operation, copyfit ) {
      if (operation === "settings") {
        if ( typeof copyfit !== 'undefined' ) {
          $scope.copyfit = copyfit;
          $scope.copyfitActive = true;

          toggleIntent( $scope.article.template, $scope.copyfit.toggleIntent.text() );
        }
      } else if (operation === "toggleIntentChanged") {
        if ($scope.copyfit) {
          toggleIntent($scope.article.template, $scope.copyfit.toggleIntent.text());
        }
      }
    });

    $scope.$on('copyfit:printServerOffline', function(event, offline) {
      setOffline(offline);
    });

    $scope.$on('copyfit:printOfflineAcknowledged', function(event, acknowledged) {
      $rootScope.printOfflineAcknowledged = acknowledged;
    });

    $scope.$on('copyfit:conflictResolved', function(event) {
      $timeout(function() {
        if ($scope.closing) {
          saveAndClose();
        } else {
          save(false);
        }
      },750);
    });

    $scope.$on('copyfit:elementNameChanged', function(event) {

      var notification = atex.act.Notification({
        type: 'warning',
        persistent: false,
        message: $scope.elementRenamedMessage
      });

      $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function(){});
      $route.reload();
    });

    $scope.simpleUID = function() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };

    var unlockAll = function () {
      return ArtCommonServices.unlockResources($scope.article).then(function () {
        return ArtCommonServices.unlockArticle($scope.article);
      });
    };

    var discardAndClose = function() {
      if (newArticle) {
        if (article.local.existsOnServer && $scope.article.meta.id) {
          ArtContentStore.remove($scope.article.meta.id).then(function() {
            setFresh();
            $scope.goToPrevious();
          }, function(error) {
            console.log('ERROR: Discarding content, ', error);
          });
        } else {
          ArtContentStore.remove($scope.article.meta.id).then(function() {
            setFresh();
            unlockAll().then(function () {
              $timeout(function () {
                ArtCommonServices.close();
              }, 500);
            });
          });
        }
      } else {
        if ( shouldSavePrintData() ) {
          ArtPrintData.sendPrintData({
            article: $scope.article,
            save: false,
            unlock: true,
            onComplete: function () {
              doDiscardAndClose();
            },
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          });
        } else {
          doDiscardAndClose();
        }
      }
    };

    var doDiscardAndClose = function() {
      $q.when(unlockOnDiscard()).then(function () {
        ArtContentStore.put(oldCopy).then(function () {
          setFresh();
          unlockAll().then(function () {
            doClose();
          });
        }, function (error) {
          console.log('ERROR: Discarding content, ', error);
        });
      });

    };

    var abortEditing = function(inhibitPrint) {
      if (typeof inhibitPrint !== 'undefined') {
        inhibitPrintAccess = inhibitPrint;
      }

      $q.when(unlockOnDiscard()).then(function () {
        setFresh();
        $scope.articleLoaded = false;
        unlockAll().then(function () {
          ArtCommonServices.close();
          $scope.closing = false;
        });
      });
    };

    var abortEditResource = function() {
      discardChanges("-1");
    };

    var discardChanges = function(newLocation) {
      var promise = $q.when(true);
      if (newArticle) {
        if ($scope.article.meta.id) {
          promise = ArtContentStore.remove($scope.article.meta.id);
        }
      } else {
        promise = $q.when(unlockOnDiscard()).then (
          ArtContentStore.put(oldCopy)
        );
      }
      $q.when(promise).then (function () {
          setFresh();
          if (typeof newLocation !== 'undefined') {
              if (newLocation === "-1") {
                $scope.goToPrevious();
              } else {
                  $location.path(newLocation);
              }
          }
      }, function (error) {
          console.log('ERROR: Discarding content, ', error);
      });

    };

    var broadcastTemporaryChanges = function(newLocation) {
      var promise = $q.when(true);
      if (newArticle) {
        if ($scope.article.meta.id) {
          promise = ArtContentStore.remove($scope.article.meta.id);
        }
      } else {
        promise = $q.when(unlockOnDiscard()).then (
          ArtContentStore.put(oldCopy)
        );
      }
      $q.when(promise).then (function () {
        setFresh();
        if (typeof newLocation !== 'undefined') {
          if (newLocation === "-1") {
            $scope.goToPrevious();
          } else {
            $location.path(newLocation);
          }
          $rootScope.$broadcast('act:broadcastTemporaryChanges',  $scope.article);    }
      }, function (error) {
        console.log('ERROR: Discarding content, ', error);
      });

    };

    var goToDashboard = function(inhibitPrint) {
      if (typeof inhibitPrint !== 'undefined') {
        inhibitPrintAccess = inhibitPrint;
      }

      if ( $rootScope.editChain ) {
        $rootScope.editChain.clear();
      }
      $location.path('/');
    };

    var doNothing = function( ) {
      var notification = atex.act.Notification({
        type: 'success',
        persistent: false,
        message: 'Operation completed successfully'
      });
      $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function(){});
    };

    $scope.goBack = function() {
      commitPrintChanges($rootScope.editChain, doNothing);
      ArtCommonServices.storeToServer($scope.article,templates);
    };

    $scope.discard = function() {
      if (newArticle) {
        if ($scope.article.meta.id) {
          ArtContentStore.remove($scope.article.meta.id).then(function() {
            $location.path('/');
          }, function(error) {
            console.log('ERROR: Discarding content, ', error);
          });
        } else {
          $location.path('/');
        }
      } else {
        unlockOnDiscard();
        ArtContentStore.put(oldCopy).then(function() {
          $location.path('/');
        }, function(error) {
          console.log('ERROR: Discarding content, ', error);
        });
      }
    };

    var goBack = function() {
      if($rootScope.editChain && $rootScope.editChain.get(0)) {
        var master = $rootScope.editChain.get(0);
        master.data.contentUpdated = true;

        $rootScope.editChain.replace(master,0);
        ArtContentStore.put(master).then(function() {
          $scope.goToPrevious();
        });
      } else {
        $scope.goToPrevious();
      }
   };

    var saveAndGoBack = _.debounce(function() {
      $scope.saving = true;
      $scope.goToDashboard = true;
      if ( shouldSavePrintData() ) {
        ArtPrintData.sendPrintData({
          article: $scope.article,
          save: true,
          unlock: true,
          onComplete: function() {
            saveDone = true;
            doSave(false);
          },
          rootScope: $rootScope,
          topDomainObject: $scope.topDomainObject
        });
      } else {
        doSave(false);
      }
    }, 800, true);

    var saveAndGoBackArticle = function() {
      save(true);
    };

    var saveAndClose = _.debounce(function( options ) {
      $scope.saving = true;
      $scope.closing = true;
      if ( shouldSavePrintData() ) {
        ArtPrintData.sendPrintData(_.extend( {
          article: $scope.article,
          save: true,
          unlock: true,
          onComplete: function() {
            saveDone = true;
            doSave(false);
          },
          rootScope: $rootScope,
          topDomainObject: $scope.topDomainObject
        },options));
      } else {
        doSave(false);
      }
    }, 800, true);

    var close = function() {
      unlockAll().then(function () {
        if (shouldSavePrintData()) {
          ArtPrintData.sendPrintData({
            article: $scope.article,
            save: false,
            unlock: true,
            onComplete: function() {
              saveDone = true;
              doClose();
            },
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          });
        } else {
          doClose();
        }
      });
    };

    function doClose() {
      $timeout(function () {
        ArtCommonServices.close();
        $scope.closing = false;
      }, 500);
    }

    var checkForConflict = function() {
      function isConflict(s, o) {

        function aspectEqual(a1, a2) {
          return _.isEqual(a1.data, a2.data);
        }

        function aspectsEqual(a, b) {
          for(var key in a) {
            if(key !== "p.ContentMetadata" && b.hasOwnProperty(key)) {
              if(!aspectEqual(a[key], b[key])) {
                console.log("has resolved conflict in ", key );
                return false;
              }
            }
          }
          return true;
        }

        return getFilterAspects().then(function(filterAspects) {

          // if does not contain aspects to be filter then assume a conflict
          if(!atex.act.AspectUtils.containsAspect(filterAspects, s)) {
            return true;
          }

          // remove aspects that will not be saved
          atex.act.AspectUtils.removeAspects(filterAspects, s);
          return !aspectsEqual(s.data.aspects, o.data.aspects);
        });
      }

      if($scope.detectChanges || !$scope.article.local.existsOnServer || newArticle) {
        return $q.when(false);
      }

      var transferInfo = {id: $scope.article.meta.id};
      return ContentService.getContent(transferInfo).then(function (serverArticle) {
        if ($scope.article.meta.revision === serverArticle.revision) {
          return false;
        }
        transferInfo = {id: $scope.article.meta.revision.replace(/["]+/g, '')};
        return ContentService.getContent(transferInfo).then(function (origArticle) {
          return isConflict(serverArticle, origArticle);
        });
      });
    };

    var doSave = function (goBack) {
      if($scope.showSpinner) {
        return;
      }

      var bgoBack = false;
      if(goBack !== undefined){
        bgoBack = goBack;
      }
      $scope.showSpinner = true;
      $scope.article.local.conflict = undefined;
      if (typeof $scope.closing === 'undefined') {
        $scope.closing = false;
      }

     return checkForConflict().then(function(conflict) {
        return ArtCommonServices.storeToServer($scope.article, templates, $rootScope.editChain.get(0)).then(function () {
              if(bgoBack) {
                  saveDone = true;
              }
              $scope.saving = false;
              setFresh();


              if (typeof $rootScope !== 'undefined' ) {
                $rootScope.$broadcast('copyfit:printDataRequest', 'saveDataComplete', {});
              }

              $scope.activeBack = $scope.hasChain() ? $scope.goBackCmd :$scope.closeCmd;
              var notification = atex.act.Notification({
                  type: 'success',
                  persistent: false,
                  message: $scope.actSuccessMessage
              });
              $scope.showSpinner = false;
              $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function(){});
              sendEvent($scope.article, "save");

              if ($scope.goToDashboard)
              {
                goToDashboard();
                $scope.goToDashboard = false;
              } else if ($scope.closing) {
                close();
              } else if (goBack) {
                if ($scope.hasPrevious()) {
                  $scope.goToPrevious();
                } else {
                  close();
                }
              } else {
              return ArtTemplateStore.getTemplateFor(article).then(function (template) {
                  if(template) {
                    return saveViewState(conflict).then(function() {
                      var id = atex.onecms.ObjectUtils.getByPath($scope.article, "data/id");
                      if (id !== undefined) {
                        if (id !== $routeParams.id) {
                          var newpath = "/edit/" + id;
                          var activeTab;
                          if (document.getElementsByClassName('tab-pill active').length > 0){
                            activeTab = document.getElementsByClassName('tab-pill active')[0].attributes['x-act-view'].value;
                            $location.path(newpath).search({tab: activeTab});
                          }else{
                            $location.path(newpath);
                          }
                        } else if (conflict) {
                          $route.reload();
                        }
                      } else {
                        console.log("undefined id for article-->" + JSON.stringify(article));
                      }
                    });
                  }
                });
              }
          }).then(null, function (error) {
            $scope.showSpinner = false;

            if (error.type === atex.onecms.error.types.CONFLICT) {
              //$scope.requestConflictResolution(JSON.parse(error.rootCause.response.extraInfo.conflicts));
              // In case of conflict always keep local version (we don't call requestConflictResolution any more) [max]
              return $scope.keepLocalVersion();
            } else {
              $scope.saving = false;
              $scope.closing = false;

              var notification = atex.act.Notification({
                type: 'error',
                persistent: true,
                message: 'Operation failed ' + error.type
              });

              ArtNotificationService.addNotification(notification, false, function () {
              });
              return $q.reject();
            }
          });
      });
    };

    var executeDeskFrame = function() {
      ArtDeskEmbed.openDeskFrame().then(function(response) {
        if ( response && response.saveAndClose ) {
          saveAndClose(response.options);
        }
      }).catch(function(error) {
        console.log("doSaveAndLinkToPage catch error = ", error);
      });
    };

    var doSaveAndLinkToPage = _.debounce(function() {
      $scope.desk['link-to-page'] = true;
      $scope.desk['select-queue'] = true;
      $scope.desk.queueOnly = false;
      $scope.desk.cmd = this;
      executeDeskFrame();
    }, 800, true);

    var doSaveAndSendToQueue = _.debounce(function() {
      $scope.desk['link-to-page'] = false;
      $scope.desk['select-queue'] = true;
      $scope.desk.queueOnly = true;
      $scope.desk.cmd = this;
      executeDeskFrame();
    }, 800, true);

    var save = _.debounce(function(goBack) {
        $scope.saving = true;
        $scope.closing = false;
        var bUnlock = false;
        if(goBack !== undefined){
          bUnlock = true;
        }
        if ($scope.article && $scope.article.meta.id && $scope.article.meta.id.indexOf('act:') === 0){
          return broadcastTemporaryChanges($scope.hasChain() === false ? '/' : "-1");
        }
        if ( shouldSavePrintData() ) {
          var deferred = $q.defer();
          ArtPrintData.sendPrintData({
            article: $scope.article,
            save: true,
            unlock: bUnlock,
            onComplete: function () {
              saveDone = true;
              doSave(goBack).then(function () {
                deferred.resolve();
              }).catch(function (error) {
                console.log('doSave failed!', error);
                deferred.reject(error);
              });
            },
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          });
          return deferred.promise;
        } else {
          return doSave(goBack);
        }
    }, 800, true);

    var createCmd = function(cmd) {
      return {
        name: cmd.name || "act.unknown.cmd",
        label: cmd.label || cmd.name,
        tooltip: cmd.tooltip || cmd.label,
        icon: cmd.icon || "",
        key: cmd.key || undefined,
        isEnabled: cmd.isEnabled || function() {
          return true;
        },
        isVisible: cmd.isVisible || function() {
          return true;
        },
        doCmd: cmd.doCmd || function() {
          return true;
        }
      };
    };

    $scope.goBackCmd = createCmd({
      name: 'act.cmd.go.back',
      label: $scope.getPreviousTooltip(),
      tooltip: $scope.getPreviousTooltip(),
      icon: 'fa-long-arrow-left',
      isEnabled: function() {
        return isFresh();
      },
      doCmd: goBack
    });

    $scope.saveCmd = createCmd({
      name: 'act.cmd.save',
      label: 'Save',
      tooltip: 'Save',
      icon: 'fa-floppy-o',
      isEnabled: function() {
        return !isFresh() && !$scope.printSyncing;
      },
      doCmd: save
    });

   $scope.saveLinkToPageCmd = createCmd({
      name: 'act.cmd.link',
      label: 'Link to Page',
      tooltip: 'Save and Link to Page',
      icon: 'fa-square-o',
      isVisible: function() {
        return $scope.desk.visibleLinkToPage;
      },
      isEnabled: function() {
        return !isNew() && !$scope.printSyncing;
      },
      doCmd: doSaveAndLinkToPage
    });

    $scope.saveSendToQueueCmd = createCmd({
      name: 'act.cmd.send',
      label: 'Send to Queue',
      tooltip: 'Save and Send to Queue',
      icon: 'fa-square-o',
      isVisible: function() {
        return $scope.desk.visibleSendToQueue;
      },
      isEnabled: function() {
        return !isNew() && !$scope.printSyncing;
      },
      doCmd: doSaveAndSendToQueue
    });

    $scope.saveAndPublishCmd = createCmd({
      name: 'act.cmd.save.publish',
      label: 'Save and publish',
      tooltip: 'Save and publish',
      icon: 'fa-floppy-o',
      isEnabled: function() {
        return !isFresh() && !$scope.printSyncing && $scope.publishEnabled  && !disabledFromProfile;
      },
      doCmd: saveAndPublish
    });

    $scope.closeCmd = createCmd({
      name: 'act.cmd.close',
      label: 'Close',
      tooltip: 'Close',
      icon: 'fa fa-times',
      isEnabled: function() {
        return  isSaved();
      },
      doCmd: close
    });

    $scope.saveAndCloseCmd = createCmd({
      name: 'act.cmd.save.close',
      label: 'Save and close',
      tooltip: 'Save and close',
      icon: 'fa-floppy-o',
      isEnabled: function() {
        return !isFresh() && !$scope.printSyncing;
      },
      doCmd: saveAndClose
    });

    $scope.backCmd = createCmd({
      name: 'act.cmd.back',
      label: 'DASHBOARD',
      tooltip: 'BACK_TIP',
      icon: 'fa-long-arrow-left',
      isVisible: function() {
        return useInbox();
      },
      isEnabled: isFresh,
      doCmd: function() {
        unlockAll().then (function () {
            $location.path('/');
        });
      }
    });

    $scope.saveAndBackCmd = createCmd({
      name: 'act.cmd.save.back',
      label: 'SAVE_AND_BACK',
      tooltip: 'SAVE_AND_BACK_TIP',
      icon: 'fa-floppy-o',
      isVisible: function() {
        return useInbox();
      },
      isEnabled: function() {
        return !isFresh() && !$scope.printSyncing;
      },
      doCmd: saveAndGoBack
    });

    $scope.saveAndBackArticleCmd = createCmd({
      name: 'act.cmd.save.back.article',
      label: 'Save and close',
      tooltip: 'Save and close',
      icon: 'fa-floppy-o',
      isEnabled: function() {
        return !isFresh() && !$scope.printSyncing;
      },
      doCmd: saveAndGoBackArticle
    });

    $scope.discardCmd = createCmd({
      name: 'act.cmd.discard',
      label: 'DISCARD_AND_BACK',
      tooltip: 'DISCARD_AND_BACK_TIP',
      icon: 'fa-remove',
      isVisible: function() {
        return $scope.hasChain() || useInbox();
      },
      isEnabled: function() {
        return !isFresh();
      },
      doCmd: function() {
        discardChanges($scope.hasChain() === false ? '/' : "-1");
      }
    });

    $scope.discardAndCloseCmd = createCmd({
      name: 'act.cmd.discard.close',
      label: 'Discard and close',
      tooltip: 'Discard and close',
      icon: 'fa-remove',
      isEnabled: function() {
        return $scope.hasChain() === false;
      },
      isVisible: function() {
        return $scope.hasChain() === false;
      },
      doCmd: function() {
        discardAndClose();
      }
    });

    var setActiveBackCmd = function()
    {
      if($scope.isPublishing) {
        return;
      }

      if ( isFresh() ) {
        $scope.activeBack = $scope.hasChain() ? $scope.goBackCmd : (isSaved()) ? $scope.closeCmd : ($scope.forceDefaultSaveButtonToSaveAndPublish  && $scope.isPublishedToWeb? $scope.saveAndPublishCmd :($scope.forceDefaultSaveButtonToSave ? $scope.saveCmd :$scope.saveAndCloseCmd));
      } else {
        $scope.activeBack = $scope.hasChain() ? $scope.saveAndBackArticleCmd :($scope.forceDefaultSaveButtonToSaveAndPublish && $scope.isPublishedToWeb? $scope.saveAndPublishCmd : ($scope.forceDefaultSaveButtonToSave ? $scope.saveCmd :$scope.saveAndCloseCmd));
      }
    };

    $translate(['DASHBOARD', 'SAVE', 'SAVE_AND_PUBLISH', 'BACK_TIP', 'SAVE_AND_BACK', 'SAVE_AND_BACK_TIP', 'DISCARD_AND_BACK',
      'DISCARD_AND_BACK_TIP', 'CLOSE', 'SAVE_AND_CLOSE', 'DISCARD_AND_CLOSE', 'OPERATION_COMPLETED_SUCCESSFULLY',
      'PUBLICATION_OPERATION_GENERIC_ERROR','PUBLICATION_OPERATION_CONTENT_LOCKED_ERROR', 'COPYFIT_ELEMENT_RENAMED',
      'SEND_TO_QUEUE','SEND_TO_QUEUE_TIP','LINK_TO_PAGE','LINK_TO_PAGE_TIP']).then(function (translations) {
      $scope.backCmd.label = translations.DASHBOARD;
      $scope.backCmd.tooltip = translations.BACK_TIP;
      $scope.saveCmd.label = translations.SAVE;
      $scope.saveCmd.tooltip = translations.SAVE;
      $scope.saveAndPublishCmd.label = translations.SAVE_AND_PUBLISH;
      $scope.saveAndPublishCmd.tooltip = translations.SAVE_AND_PUBLISH;
      $scope.saveAndBackCmd.label = translations.SAVE_AND_BACK;
      $scope.saveAndBackCmd.tooltip = translations.SAVE_AND_BACK_TIP;
      $scope.discardCmd.label = translations.DISCARD_AND_BACK;
      $scope.discardCmd.tooltip = translations.DISCARD_AND_BACK_TIP;
      $scope.closeCmd.label = translations.CLOSE;
      $scope.closeCmd.tooltip = translations.CLOSE;
      $scope.saveAndCloseCmd.label = translations.SAVE_AND_CLOSE;
      $scope.saveAndCloseCmd.tooltip = translations.SAVE_AND_CLOSE;
      $scope.saveAndBackArticleCmd.label = translations.SAVE_AND_CLOSE;
      $scope.saveAndBackArticleCmd.tooltip = translations.SAVE_AND_CLOSE;
      $scope.discardAndCloseCmd.label = translations.DISCARD_AND_CLOSE;
      $scope.discardAndCloseCmd.tooltip = translations.DISCARD_AND_CLOSE;
      $scope.actSuccessMessage = translations.OPERATION_COMPLETED_SUCCESSFULLY;
      $scope.actPublicationErrorMessage = translations.PUBLICATION_OPERATION_GENERIC_ERROR;
      $scope.actPublicationErrorContentLockedMessage = translations.PUBLICATION_OPERATION_CONTENT_LOCKED_ERROR;
      $scope.elementRenamedMessage = translations.COPYFIT_ELEMENT_RENAMED;
      $scope.saveSendToQueueCmd.label = translations.SEND_TO_QUEUE;
      $scope.saveSendToQueueCmd.tooltip = translations.SEND_TO_QUEUE_TIP;
      $scope.saveLinkToPageCmd.label = translations.LINK_TO_PAGE;
      $scope.saveLinkToPageCmd.tooltip = translations.LINK_TO_PAGE_TIP;
    });

    setActiveBackCmd();

    var setOffline = function(offline) {
      if ($rootScope.printOffline !== offline) {
        $rootScope.printOffline = offline;

        if (!offline) {
          $rootScope.$broadcast('copyfit:printOfflineAcknowledged', false);
        }
      }
    };

    $scope.isOffline = function() {
      return $rootScope.printOffline;
    };

    var saveArticle = function(silentSave, data) {
      var oldValidState = $scope.article.local.valid;
      var oldModificationDate = $scope.article.meta.modificationDate;
      var oldData = $scope.article.data;

      if (typeof data !== 'undefined') {
        $scope.article.data = data;
      }

      if (!silentSave) {
        $scope.article.local.valid = $scope.myForm.$valid;
        $scope.article.meta.modificationDate = new Date();
        $scope.article.local.persisted = false;
      }

      if (newArticle === true) {
        var associatedSites = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/p.InsertionInfo/data/associatedSites');
        var taxonomyIds = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/atex.Metadata/data/taxonomyIds');

        if (typeof associatedSites !== 'undefined' && associatedSites.length > 0) {
          window.localStorage['act.user.associatedSites'] = JSON.stringify(associatedSites);
        }

        if (typeof taxonomyIds !== 'undefined' && taxonomyIds.length > 0) {
          window.localStorage['act.user.taxonomyIds'] = JSON.stringify(taxonomyIds);
        }
      }

      $rootScope.PageTitle = PageTitle;
      PageTitle.setTitle($scope.getWindowTitle(article));

      ArtContentStore.put($scope.article).then(function() {
        if (!silentSave) {
          clearFresh();
        }

        if ($scope.webPreviewEnabled === true) {
          // We reset the calculated preview context and try to re-discover possible
          // preview contexts as a background task...

          delete $scope.webPreviewContexts;

          var associatedSitesDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, 'aspects/p.InsertionInfo/data/associatedSites');

          if (typeof associatedSitesDomainObject !== 'undefined') {
            readAssociatedSites(associatedSitesDomainObject.getAll());
          }
        }
      }, function(error) {
        console.log('ERROR: Autosaving content, ', error);

        $scope.article.data = oldData;
        $scope.article.local.valid = oldValidState;
        $scope.article.meta.modificationDate = oldModificationDate;
      });
    };

    $scope.changeStartCallback = function() {
      $scope.article.dirty = true;
    };

    $scope.changeEndCallback = function(data) {
      $scope.article.dirty = false;
      var silent = $scope.saveAsSilentAfterChange;
      saveArticle(silent, data);
      ArtContentStore.setModifiedState($scope.article).then( function(content) {
        $scope.article = content;
        $scope.saveAsSilentAfterChange = false;
      });
    };

    $scope.initCallback = function() {
      console.log("INFO: Current Template id: " + $scope.article.template.id);

      $scope.copyfit = undefined;

      $scope.isContentEditorLoading = true;
      var actLoaded = sessionStorage.getItem("act.loaded") || "";

      if ( $scope.copyfitActive && actLoaded !== "" && actLoaded === $scope.article.meta.id ) {
        actReloaded = true;
      }

      if ( newArticle ) {
        sessionStorage.setItem("act.loaded", "");
      } else {
        sessionStorage.setItem("act.loaded", $scope.article.meta.id);

        ArtContentStore.setModifiedState($scope.article).then( function(content) {
          $scope.article = content;
        });
      }
    };

    $scope.loadCallback = function() {
      $scope.isContentEditorLoading = false;
    };

    $scope.error = function(error) {
      Application.currentErrorInfo = { error: error };
      $location.path("/error");
    };

    var washContentId = function(id) {
      var washedId = id.replace(/contentid\//ig, '').replace(/externalid\//ig, '');
      return (washedId.indexOf('policy:') === -1) ? 'policy:' + washedId : washedId;
    };

    var readAssociatedSites = function(associatedSiteIds) {
      var promises = (associatedSiteIds || []).map(function(associatedSiteId) {
        return ContentService.getContent({ id: associatedSiteId }).then(function(responseInfo) {
          var siteName = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/name') || washContentId(associatedSiteId);

          return {
            id: washContentId(associatedSiteId),
            name: siteName
          };
        });
      });

      return $q.all(promises).then(function(results) {
        $scope.webPreviewPossibleContexts = results;
      }).then(undefined, function(error) {
        console.warn('Failed to read associated sites from server!', error);
      });
    };

    var selectFirstWorkingSite = function(workingSites, selectedAssociatedSites, selectedTaxonomyIds) {
      if (typeof workingSites !== 'undefined' && workingSites.length > 0) {
        return ContentService.getContent({ id: 'externalid/' + workingSites[0].id }).then(function(responseInfo) {
          var externalIdAlias = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/atex.Aliases/data/aliases/externalId');

          selectedTaxonomyIds.push(externalIdAlias);
          selectedAssociatedSites.push('contentid/' + responseInfo.id);
        });
      }

      return $q.when();
    };

    var lockPrintAttributes = false;

    $scope.prepareEdit = function(topDomainObject) {
      $scope.topDomainObject = topDomainObject;

      if (typeof $rootScope.editChain !== 'undefined') {
        $scope.editChainEventHandler = $scope.topDomainObject.on('act:resource-remove', function(event, resourceId) {
          $rootScope.editChain.sliceFrom(resourceId);
        });
      }


      lockPrintAttributes = false;

      if (typeof $scope.article.template.copyfitOptions !== 'undefined' && typeof $scope.article.template.copyfitOptions.editAllAspects !== 'undefined') {
        lockPrintAttributes = $scope.article.template.copyfitOptions.editAllAspects;
      }

      var editionId = $route.current.params.edition || "0";

      var fetchOptions = {  topDomainObject: topDomainObject,
                            newArticle: newArticle,
                            actReloaded: actReloaded,
                            printPreviewDisabled: $scope.printPreviewDisabled,
                            lock: lockPrintAttributes,
                            clearFresh: clearFresh,
                            rootScope: $rootScope,
                            saveArticle: saveArticle,
                            edition: editionId,
                            abortEditing: $scope.hasChain() === false ? abortEditing : abortEditResource
                          };

      var taxonomyIdsDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/atex.Metadata/data/taxonomyIds');
      var associatedSitesDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/p.InsertionInfo/data/associatedSites');
      var skipSetFirstWorkingSite = true; // Avoid set as associated site a random first working Site [max]
      if (!skipSetFirstWorkingSite && typeof taxonomyIdsDomainObject !== 'undefined' && typeof associatedSitesDomainObject !== 'undefined' && newArticle === true) {
        var selectedAssociatedSites = (typeof window.localStorage['act.user.associatedSites'] !== 'undefined')
          ? JSON.parse(window.localStorage['act.user.associatedSites'])
          : [];

        var selectedTaxonomyIds = (typeof window.localStorage['act.user.taxonomyIds'] !== 'undefined')
          ? JSON.parse(window.localStorage['act.user.taxonomyIds'])
          : [];

        var selectionPromise = $q.when( ArtPrintData.fetchPrintData( fetchOptions ) );

        var workingSites = atex.onecms.ObjectUtils.getByPath($scope.user, 'aspects/contentData/data/workingSites');

        if (selectedAssociatedSites.length === 0 || selectedTaxonomyIds.length === 0) {
          selectionPromise = selectFirstWorkingSite(workingSites, selectedAssociatedSites, selectedTaxonomyIds);
        } else {
          var valid = true;

          if (typeof workingSites === 'undefined' || workingSites.length < selectedAssociatedSites.length) {
            valid = false;
          } else {
            valid = selectedTaxonomyIds.filter(function(taxonomyId) {
              return _.where(workingSites, { id: taxonomyId }).length !== 0;
            }).length === selectedTaxonomyIds.length;
          }

          if (valid === false) {
            selectedAssociatedSites = [];
            window.localStorage.removeItem('act.user.associatedSites');

            selectedTaxonomyIds = [];
            window.localStorage.removeItem('act.user.taxonomyIds');

            selectionPromise = selectFirstWorkingSite(workingSites, selectedAssociatedSites, selectedTaxonomyIds);
          }
        }

        return selectionPromise.then(function() {
          selectedAssociatedSites.forEach(function(site) {
            associatedSitesDomainObject.add(site);
          });

          selectedTaxonomyIds.forEach(function(taxonomyId) {
            taxonomyIdsDomainObject.add(taxonomyId);
          });

          if ($scope.webPreviewEnabled === true) {
            return readAssociatedSites(associatedSitesDomainObject.getAll()).then(function() {
              topDomainObject.changed(); // clear any dirty-state...
            });
          }

          topDomainObject.changed(); // clear any dirty-state...
        }).then(undefined, function(error) {
          var errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined') ? error.cause : 'unknown error';

          var wrappedError = atex.onecms.error.Error({
            rootCause: error,
            severity: atex.onecms.error.severities.NORMAL,
            origin: 'Contributor Tool Detail View Controller',
            cause: 'Error while preparing content for editing: ' + errorMessage
          });

          console.warn(wrappedError);

          var notification = atex.act.Notification({
            type: 'warning',
            persistent: false,

            message: 'The Contributor Tool failed to automatically select a site for this content! Please see the ' +
                     'console log for more information.'
          });

          $scope.siteSelectionToast = ArtNotificationService.addNotification(notification, false, function(){});
        });
      } else {
        var printDataPromise = $q.when(ArtPrintData.fetchPrintData( fetchOptions ));

        if ($scope.webPreviewEnabled === true && typeof associatedSitesDomainObject !== 'undefined') {
          return readAssociatedSites(associatedSitesDomainObject.getAll()).then(function() {
            return printDataPromise;
          });
        }

        return printDataPromise;
      }
    };
  }
]);

/**
 * TODO: These resolves should probably be factories.
 */
var ArticleDetailController = {
  editResolves : {
    'preload-factory' : function(PreloadService) {
      return PreloadService.preloadFactoryList('actList');
    },
    'article': function($route, $q, $location, $rootScope, $translate, ArtSynchronizationService, ArtContentStore, ArtTemplateStore, ArtLockingService, ArtLockModal) {
      var _article = null;
      return ArtSynchronizationService.whenSynchronized({
        ids: [$route.current.params.id]
      }).then(function () {
        return ArtContentStore.getById($route.current.params.id, $route.current.params.force).then(function (article) {
          _article = article;
          return ArtTemplateStore.getTemplateFor(article).then(function (template) {
            if (typeof template === 'undefined') {
              return $q.reject(atex.onecms.error.Error({
                origin: 'Contributor Tool Detail View Controller',
                type: atex.onecms.error.types.INVALID_PARAMETERS,
                severity: atex.onecms.error.severities.CRITICAL,
                cause: "No applicable template information was found for type '" + article.data.aspects.contentData.data._type + "'! Cannot edit content..."
              }));
            }

            return template;
          });
        }).then(function (template) {
          _article.template = template;

          return $translate(['CONFIRM_HEADER', 'LOCK_MESSAGE']).then(function (translations) {
            return ArtLockingService.isLocked(_article.meta.id).then(function (locked) {
              if (locked && locked.byMe && !$rootScope.lockResolved) {
                $rootScope.lockResolved = true;

                return ArtLockModal.create({
                  'confirmHeader': translations.CONFIRM_HEADER,
                  'confirmBody': translations.LOCK_MESSAGE,
                  'mode': 'primary'
                }).then(function (confirmed) {
                  if (confirmed === 'ok') {
                    if (_article.local.existsOnServer && _article.local.persisted) {
                      return ArtLockingService.lock([_article.meta.id]).then(function () {
                        return _article;
                      }, function (error) {
                        if (error.notified || false) {
                          error = atex.onecms.error.Error({
                            origin: 'Contributor Tool Detail View Controller',
                            type: 'contentLocked',
                            severity: atex.onecms.error.severities.NORMAL,
                            cause: "Locked! Cannot edit content...",
                            path: "/preview/" + _article.meta.id
                          });
                        }
                        return $q.reject(error);
                      });
                    } else {
                      return _article;
                    }
                  }

                  if (confirmed === 'cancel') {
                    var error = atex.onecms.error.Error({
                      severity: atex.onecms.error.severities.NORMAL,
                      path: "/"
                    });

                    return $q.reject(error);
                  }
                });
              } else {
                $rootScope.lockResolved = true;

                if (_article.local.existsOnServer) {
                  return ArtLockingService.lock([_article.meta.id]).then(function () {
                    return _article;
                  }, function (error) {
                    if (error.notified || false) {
                      error = atex.onecms.error.Error({
                        origin: 'Contributor Tool Detail View Controller',
                        type: 'contentLocked',
                        severity: atex.onecms.error.severities.NORMAL,
                        cause: "Locked! Cannot edit content...",
                        path: "/preview/" + _article.meta.id
                      });
                    }
                    return $q.reject(error);
                  });
                } else {
                  return _article;
                }
              }
            });
          });
        });
      });
    },

    'user': function(ArtUserDataStore, AuthenticationService) {
      return AuthenticationService.getCurrentUser().then(function(currentUser) {
        return ArtUserDataStore.getById(currentUser.userId);
      });
    },

    'templates': function(ArtTemplateStore) {
      return ArtTemplateStore.getAll();
    }
  },

  editUsingResolves : {
    'preload-factory': function (PreloadService) {
      return PreloadService.preloadFactoryList('actList');
    },
    'article': function ($route, $q, $rootScope, $translate, ArtSynchronizationService, ArtContentStore, ArtTemplateStore, ArtLockingService, ArtLockModal) {
      var _article = null;

      return ArtSynchronizationService.whenSynchronized({
        ids: [$route.current.params.id]
      }).then(function () {
        return ArtContentStore.getById($route.current.params.id, $route.current.params.force).then(function (article) {
          _article = article;

          return ArtTemplateStore.getById($route.current.params.templateId).then(function (template) {
            if (typeof template === 'undefined') {
              return $q.reject(atex.onecms.error.Error({
                origin: 'Contributor Tool Detail View Controller',
                type: atex.onecms.error.types.INVALID_PARAMETERS,
                severity: atex.onecms.error.severities.CRITICAL,
                cause: "No applicable template information was found for type '" + article.data.aspects.contentData.data._type + "'! Cannot edit content..."
              }));
            }

            return template;
          });
        }).then(function (template) {
          _article.template = template;

          atex.onecms.ObjectUtils.accessor(_article.data, 'aspects/atex.OneCMS/data/_type').value = "atex.OneCMS";
          atex.onecms.ObjectUtils.accessor(_article.data, 'aspects/atex.OneCMS/data/createdWithTemplate').value = template.id;
          atex.onecms.ObjectUtils.accessor(_article.data, 'aspects/atex.OneCMS/data/createdWithTemplate_type').value = "java.lang.String";

          return $translate(['CONFIRM_HEADER', 'LOCK_MESSAGE']).then(function (translations) {
            return ArtLockingService.isLocked(_article.meta.id).then(function (locked) {
              if (locked && locked.byMe && !$rootScope.lockResolved) {
                $rootScope.lockResolved = true;

                return ArtLockModal.create({
                  'confirmHeader': translations.CONFIRM_HEADER,
                  'confirmBody': translations.LOCK_MESSAGE,
                  'mode': 'primary'
                }).then(function (confirmed) {
                  if (confirmed === 'ok') {
                    if (_article.local.existsOnServer && _article.local.persisted) {
                      return ArtLockingService.lock([_article.meta.id]).then(function () {
                        return _article;
                      }, function (error) {
                        if (error.notified || false) {
                          error = atex.onecms.error.Error({
                            origin: 'Contributor Tool Detail View Controller',
                            type: 'contentLocked',
                            severity: atex.onecms.error.severities.NORMAL,
                            cause: "Locked! Cannot edit content...",
                            path: "/preview/" + _article.meta.id
                          });
                        }
                        return $q.reject(error);
                      });
                    } else {
                      return _article;
                    }
                  }

                  if (confirmed === 'cancel') {
                    var error = atex.onecms.error.Error({
                      severity: atex.onecms.error.severities.NORMAL,
                      path: "/"
                    });

                    return $q.reject(error);
                  }
                });

              } else {
                $rootScope.lockResolved = true;

                if (_article.local.existsOnServer) {
                  return ArtLockingService.lock([_article.meta.id]).then(function () {
                    return _article;
                  }, function (error) {
                    if (error.notified || false) {
                      var returnPath = $rootScope.lastCurrent || "xx";
                      error = atex.onecms.error.Error({
                        origin: 'Contributor Tool Detail View Controller',
                        type: 'contentLocked',
                        severity: atex.onecms.error.severities.NORMAL,
                        cause: "Locked! Cannot edit content...",
                        path: "/preview/" + _article.meta.id
                      });
                    }
                    return $q.reject(error);
                  });
                } else {
                  return _article;
                }
              }
            });
          });
        });

      });
    },

    'user': function (ArtUserDataStore, AuthenticationService) {
      return AuthenticationService.getCurrentUser().then(function (currentUser) {
        return ArtUserDataStore.getById(currentUser.userId);
      });
    },

    'templates': function (ArtTemplateStore) {
      return ArtTemplateStore.getAll();
    }
  },

  newResolves : {
    'preload-factory' : function(PreloadService) {
      return PreloadService.preloadFactoryList('actList');
    },
    'article': function($route, $q, ArtTemplateStore, $parse, $rootScope, ArtUserDataStore, AuthenticationService, ArtSynchronizationService) {
      return AuthenticationService.getCurrentUser().then(function(currentUser) {
        return ArtUserDataStore.getById(currentUser.userId);
      }).then(function(userData) {
        $rootScope.currentUser = userData;
        $rootScope.currentUser.fullName = $rootScope.currentUser.aspects.contentData.data.firstname + " " + $rootScope.currentUser.aspects.contentData.data.surname;

        return ArtSynchronizationService.whenSynchronized({
          onlyTemplates: true
        }).then(function() {
          return ArtTemplateStore.getById($route.current.params.type).then(function (template) {
            if (typeof template === 'undefined') {
              return $q.reject(atex.onecms.error.Error({
                origin: 'Contributor Tool Detail View Controller',
                type: atex.onecms.error.types.INVALID_PARAMETERS,
                severity: atex.onecms.error.severities.CRITICAL,

                cause: "No template '" + $route.current.params.type + "' found! Cannot create content..."
              }));
            }


            var article = atex.Content(template);

            // The edit chain functionality won't work property without an ID present...
            article.meta.id = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

            for (var j = 0; j < template.dataBindings.length; j++) {
              var field = template.dataBindings[j];

              if (field.default !== undefined) {
                var shortPath = field.path || field.domainObject || field.domainObjects.data;
                var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);
                try {
                  if (field.default.value !== undefined) {
                    atex.onecms.ObjectUtils.accessor(article.data.aspects, path).value = field.default.value;
                  } else if (field.default.expression !== undefined) {
                    var getter = $parse(field.default.expression);
                    var expr = getter($rootScope);
                    if (field.config !== undefined && field.config.dimensions !== undefined && field.config.dimensions.length > 0) {
                      var dimensionId = field.config.dimensions[0];
                      if (dimensionId === "dimension.Author") {
                        var entities = [{
                          "childrenOmitted": false,
                          "localizations": {},
                          "entities": [],
                          "id": expr,
                          "attributes": [],
                          "name": expr
                        }];

                        article.data.aspects['atex.Metadata'] = {
                          data: {
                            _type: 'atex.Metadata',
                            taxonomyIds: ['p.StandardCategorization'],
                            metadata: {
                              dimensions: [{
                                "localizations": {},
                                "enumerable": false,
                                "entities": entities,
                                "id": dimensionId
                              }]
                            }
                          }
                        };
                      }
                    } else {
                      atex.onecms.ObjectUtils.accessor(article.data.aspects, path).value = expr;
                    }
                  }
                } catch (e) {
                  console.log(e);
                  atex.onecms.ObjectUtils.accessor(article.data.aspects, path).value = e;
                }
              }

            }

            return article;
          });
        });
      });
    },

    'user': function(ArtUserDataStore, AuthenticationService) {
      return AuthenticationService.getCurrentUser().then(function(currentUser) {
        return ArtUserDataStore.getById(currentUser.userId);
      });
    },

    'templates': function(ArtTemplateStore) {
      return ArtTemplateStore.getAll();
    }
  }
};
